import React from 'react'
import { Typography } from '@material-ui/core'
import { useStepLoriStyles } from '../styles'

interface WelcomeItem {
    label: string
    description: string
    optional?: boolean
}

const welcomeItems: WelcomeItem[] = [
    {
        label: 'Work start date',
        description: 'Date work begins.',
    },
    {
        label: 'Work end date',
        description: 'Date work is completed.',
    },
    {
        label: 'Transfer start date',
        description:
            'TIs are scheduled prior to this date. If you provide this date, you must also provide the transfer end date. You may choose the same start and end date.',
        optional: true,
    },
    {
        label: 'Transfer end date',
        description:
            'TOs are scheduled after this date. If you provide this date, you must also provide the transfer start date. You may choose the same start and end date.',
        optional: true,
    },
    {
        label: 'Units',
        description: 'Units which should be apart of this project.',
    },
    {
        label: 'Services & Vendors',
        description:
            'Set of services in order of completion with associated vendors for each service.',
    },
]

export const AdvancedLoriWelcome = () => {
    const classes = useStepLoriStyles()

    return (
        <div className={classes.welcomeCard}>
            {/* <Typography variant="body2" className={classes.welcomeSubtitle}>
                To use a previous project as a template, just say &quot;use a template&quot;.
            </Typography> */}
            <Typography variant="body2" className={classes.welcomeSubtitle}>
                Advanced Lori can setup your entire project in one shot. Simply
                provide the details below and Lori will take care of the rest.
                This feature is currently in beta and if you encounter repeated
                error messages, please consider using the auto scheduler or step
                by step Lori instead.
            </Typography>
            <ul className={classes.welcomeList}>
                {welcomeItems.map((item) => (
                    <li key={item.label} className={classes.welcomeListItem}>
                        <div className={classes.welcomeListHeader}>
                            <Typography
                                component="span"
                                className={classes.welcomeLabel}
                            >
                                {item.label}
                            </Typography>
                            {item.optional && (
                                <Typography
                                    component="span"
                                    className={classes.welcomeOptional}
                                >
                                    Optional
                                </Typography>
                            )}
                        </div>
                        <Typography
                            variant="body2"
                            className={classes.welcomeDescription}
                        >
                            {item.description}
                        </Typography>
                    </li>
                ))}
            </ul>
        </div>
    )
}
